import PropTypes from 'prop-types'
import React from 'react'

//components
import { CImage } from '@coreui/react'

//style
import style from './tagLable.module.scss'

//icons
import { closeIcon, infoIconWhite } from 'src/asset/icon'

const TagLabel = ({
  label,
  variant,
  type,
  visible,
  setIsVisible,
  isCloseable,
  useDefaultIcon,
  isBordered,
  onClose,
  startIcon,
  endIcon,
  onFirstIconClick,
  textClassName = '',
  onClick,
  endIconSize,
  className = '',
  onEndIconClick,
  size = '',
}) => {
  const iconVariant = {
    ai: infoIconWhite,
  }

  if (!visible) return null

  return (
    <div
      className={`d-flex ${className?style[className]:''} ${style['tag-label']} ${
        style[`${variant}__${type}`]
      } ${size ? `${style[`${variant}__${size}`]}` : ''} ${
        isBordered ? `${style[`${variant}__bordered`]}` : ''
      }`}
    >
      <div className="d-flex gap-1 align-items-center">
        {startIcon && (
          <CImage
            id="startTagIcon"
            src={startIcon}
            width={10}
            height={10}
            onClick={onFirstIconClick}
          />
        )}

        <div id="tagnameLabelClick" className={`d-flex h-auto ${textClassName}`} onClick={onClick}>
          {label}
        </div>

        {isCloseable ? (
          <CImage id="tagsCloseIcon" src={closeIcon} width={10} height={10} onClick={onClose} />
        ) : (
          endIcon && (
            <CImage
              src={endIcon}
              width={endIconSize ?? 10}
              height={endIconSize ?? 10}
              id="endIcon"
              onClick={onEndIconClick}
            />
          )
        )}
        {!isCloseable && useDefaultIcon && (
          <CImage src={iconVariant[variant]} width={10} height={10} />
        )}
      </div>
    </div>
  )
}

TagLabel.defaultProps = {
  type: 'primary',
  variant: 'success',
}

TagLabel.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'alert', 'ai', 'basic', 'disabled', 'info', 'error']),
  type: PropTypes.oneOf(['primary', 'secondary']),
  visible: PropTypes.bool,
  setIsVisible: PropTypes.func,
  isCloseable: PropTypes.bool,
  useDefaultIcon: PropTypes.bool,
  isBordered: PropTypes.bool,
  onClose: PropTypes.bool,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  onFirstIconClick: PropTypes.func,
  textClassName: PropTypes.string,
  onClick: PropTypes.func,
  endIconSize: PropTypes.number,
  className: PropTypes.string,
  onEndIconClick: PropTypes.func,
  size: PropTypes.oneOf(['sm', '']),
}

export default TagLabel
